module.exports = __webpack_public_path__ + "static/media/FireBird.4979c30d.jpg";